import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { NavigationContext, NavigationProviderProps } from './navigationContextHelper.tsx';

export function NavigationProvider({ children }: NavigationProviderProps) {
  const location = useLocation();
  const previousPathRef = useRef<string>(location.pathname);

  useEffect(() => {
    previousPathRef.current = location.pathname;
  }, [location]);

  return (
    <NavigationContext.Provider value={previousPathRef.current}>
      {children}
    </NavigationContext.Provider>
  );
}
